export const OPTIMIZELY_USER_ID = 'optimizely_user_id';

export const OPTIMIZELY_USER_GROUP = 'optimizely_user_group';

export const EDS_SITE_NAV = 'self-service-site-nav';
